
import { defineComponent } from 'vue'

interface ZRadioGroupT extends Vue {
  modelValue: string
  value?: string
  disabled: boolean
  readOnly: boolean
}

export default defineComponent({
  name: 'ZRadio',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      required: true
    },
    value: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    modelData(): string {
      const $parent = this.$parent as ZRadioGroupT
      return $parent?.modelValue || this.modelValue
    },
    isChecked(): boolean {
      return this.modelData === this.value
    },
    isDisabled(): boolean {
      const $parent = this.$parent as ZRadioGroupT
      return $parent?.disabled || this.disabled
    },
    isReadOnly(): boolean {
      const $parent = this.$parent as ZRadioGroupT
      return $parent?.readOnly || this.readOnly
    }
  },
  methods: {
    updateInput() {
      const $parent = this.$parent as ZRadioGroupT
      if (!this.isDisabled && !this.isReadOnly) {
        $parent.value = this.value
      }
    }
  }
})
